const INITIAL_CONVERSION_RATES = null;
const INITIAL_SUPPORTED_CURRENCIES = null;

let inMemoryConversionRates = INITIAL_CONVERSION_RATES;
let inMemorySupportedCurrencies = INITIAL_SUPPORTED_CURRENCIES;

function setConversionRates(conversionRates) {
    inMemoryConversionRates = conversionRates;
}

function getConversionRates() {
    return inMemoryConversionRates;
}

function getSupportedCurrencies() {
    return inMemorySupportedCurrencies;
}

function setSupportedCurrencies(supportedCurrencies) {
    inMemorySupportedCurrencies = supportedCurrencies;
}

function clearConversionRates() {
    inMemoryConversionRates = INITIAL_CONVERSION_RATES;
}

function clearSupportedCurrencies() {
    inMemorySupportedCurrencies = INITIAL_SUPPORTED_CURRENCIES;
}

export {
    clearConversionRates,
    clearSupportedCurrencies,
    getConversionRates,
    getSupportedCurrencies,
    setConversionRates,
    setSupportedCurrencies,
};

export default {
    getConversionRates,
    setConversionRates,
    getSupportedCurrencies,
    setSupportedCurrencies,
    clearConversionRates,
    clearSupportedCurrencies,
};
